import React, { useEffect, useRef, useState } from "react";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { TbPhotoPlus } from "react-icons/tb";
import { FaAngleLeft } from "react-icons/fa";
import { Button, message } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { restaurentMenuadd } from "../../../redux/Restaurant/RestaurantSlice";
import { get_token_data } from "../../../components/utility/Get_token_data";

const MenuAdd = () => {
  const dispatch = useDispatch();

  const { category_all } = useSelector((store) => store.category);
  const { restaurant_all } = useSelector((store) => store.restaurant);
  const [restaurent_category, Setrestaurent_category] = useState([]);

  const [categoryName, setCategoryName] = useState("");
  const [menuname, setmenuname] = useState("");
  const [resto_data, setresto_data] = useState("");
  const [button_press, setButton_press] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (restaurant_all.length > 0) {
      const find_resto = restaurant_all.find(
        (data) => data.mobile === Number(8328059954)
      );
      if (find_resto) {
        setresto_data(find_resto);
        Setrestaurent_category([...find_resto.categories]);
      }
    }
  }, [restaurant_all]);

  const submitPress = async () => {
    setButton_press(true);
    const data = get_token_data();
    if (categoryName !== "" && menuname !== "") {
      const find_category = category_all.find(
        (data) => data.name === categoryName
      );
      const formdata = {
        category: categoryName,
        categoryurl: find_category.slugUrl,
        name: menuname,
        status: true,
        RestaurentId: resto_data._id,
      };
      const form_posting = await dispatch(restaurentMenuadd(formdata));
      if (form_posting.payload.success === true) {
        messageApi.open({
          type: "success",
          content: `Menu add Successfully`,
        });
        setCategoryName("");
        setmenuname("");
        setButton_press(false);
      }
    }
  };
  const input_lable_style = {
    color: "#1a1a1a",
    fontSize: "0.75rem",
    fontWeight: "800",
    marginBottom: "0.5vh",
    textTransform: "uppercase",
  };

  return (
    <>
      {contextHolder}
      <div className="add_page_main">
        <div className="add_hedaer_main_cnf">
          <div className="add_page_header">
            <h4>Add New Menu</h4>
            <Link to="/admin/menu-list">
              <div className="bac_add_nav">
                <span>
                  <FaAngleLeft color="#333333" />
                </span>
                <h6>Menu List</h6>
              </div>
            </Link>
          </div>
        </div>
        <div className="add_input_box_main">
          <div className="add_page">
            <div className="input_container">
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Select Category <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-select"
                  select
                  variant="outlined"
                  size="small"
                  className="input_container"
                  defaultValue="Select Category"
                  error={
                    categoryName === "" && button_press === true ? true : false
                  }
                  helperText={
                    categoryName === "" && button_press === true
                      ? "Select category"
                      : ""
                  }
                  InputProps={{
                    style:
                      categoryName === "" && button_press === true
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                >
                  {restaurent_category.map((data, index) => (
                    <MenuItem key={index} value={data}>
                      {data}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Name
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter text here"
                  variant="outlined"
                  error={
                    menuname === "" && button_press === true ? true : false
                  }
                  helperText={
                    menuname === "" && button_press === true ? "Enter Name" : ""
                  }
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => setmenuname(e.target.value)}
                  value={menuname}
                  InputProps={{
                    style:
                      menuname === "" && button_press === true
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="submit_btn_container">
                <Button
                  className="confirm_btn sub_padding"
                  onClick={() => submitPress()}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuAdd;
